module.exports = __webpack_public_path__ + "static/media/cellfinate_social_3.99713317.jpg";